var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlaceholderAvatar1 = function SvgPlaceholderAvatar1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 42.5,
    fill: "#F8A963",
    stroke: "#F8A963"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 74.171V72.7894C15 63.3394 34.6456 58.5789 44.4868 58.5789C54.3281 58.5789 73.9737 63.3394 73.9737 72.7894V74.171C66.7696 82.0382 56.2294 87 44.4869 87C32.7443 87 22.2041 82.0381 15 74.171ZM44.4868 27C36.3411 27 29.7434 33.3592 29.7434 41.2105C29.7434 49.0618 36.3411 55.421 44.4868 55.421C52.6326 55.421 59.2302 49.0618 59.2302 41.2105C59.2302 33.3592 52.6326 27 44.4868 27Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderAvatar1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder-avatar-1.891238c585273886267db946aae289b3.svg";